import { render, staticRenderFns } from "./AcademicSettings.vue?vue&type=template&id=47d6fa0f&scoped=true"
import script from "./AcademicSettings.vue?vue&type=script&lang=js"
export * from "./AcademicSettings.vue?vue&type=script&lang=js"
import style0 from "./AcademicSettings.vue?vue&type=style&index=0&id=47d6fa0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d6fa0f",
  null
  
)

export default component.exports